export default "__VITE_PUBLIC_ASSET__eee21bab__"